import {initCustomSelects} from './customSelect';

let filteredPosts;
let selectedSubject = '';
let selectedTopic = '';
let selectedGrade = '';
let resultsDisplay = null;


// Initialize filter sections
const postFilters = document.querySelector('[data-posts-filters]');
if(postFilters){

    // get elements
    resultsDisplay = document.querySelector('.post-filters__results');

    // get variables from filters
    selectedSubject = postFilters.dataset.subject;
    selectedTopic = postFilters.dataset.topic;
    selectedGrade = postFilters.dataset.grade;
   
    // setup section filter toggle buttons click event
    const toggle = postFilters.querySelector('.post-filters__toggle');
    if(toggle){
        toggle.addEventListener('click',event=>{
            postFilters.classList.toggle('post-filters--visible');
        });
    }
    
    setPostsFilterSelectOptions();

    renderPostList();
}

function renderPostList(){
    filterPosts();
    printPosts();
    setPostListUrlParameters();
    setResults();
}

function filterPosts(){
    filteredPosts = posts.filter(post => {
        const subjectMatchesOrNotSet = ( selectedSubject == '' || post.subject.includes(selectedSubject) );
        const topicMatchesOrNotSet = ( selectedTopic == '' || post.topic.includes(selectedTopic) );
        const gradeMatchesOrNotSet = ( selectedGrade == '' || post.grade.includes(selectedGrade) );
        return subjectMatchesOrNotSet && gradeMatchesOrNotSet && topicMatchesOrNotSet;
    });
}

function printPosts() {
    const postList = document.querySelector('[data-post-list-items]');
    if(postList){
        postList.innerHTML = getPostsHtml();
    }
}

function setPostListUrlParameters() {
    // init parameters
    let urlParameters = [];
    // add subject and grade
    selectedSubject !== '' && urlParameters.push('subject=' + selectedSubject);
    selectedTopic !== '' && urlParameters.push('topic=' + selectedTopic);
    selectedGrade !== '' && urlParameters.push('grade=' + selectedGrade);
    // concatenate all parameter groups
    const finalUrlParameters = urlParameters.length > 0 ? '?' + urlParameters.join('&') : '';
    // add state to history
    if (finalUrlParameters != '') {
        history.pushState({ page: 'Post List' }, "Filtering", finalUrlParameters);
    } else {
        history.replaceState({}, '', location.pathname);
    }
}

function setResults(){
    if(resultsDisplay){
        resultsDisplay.innerHTML =  `${filteredPosts.length} result${filteredPosts.length !== 1 ? `s` : ``}`;
    }
}

function getPostsHtml(){

    const currentFilters = [
        selectedSubject && allSubjects.find(t => t.slug === selectedSubject).name,
        selectedTopic && allTopics.find(t => t.slug === selectedTopic).name,
        selectedGrade && allGrades.find(t => t.slug === selectedGrade).name
    ].filter(Boolean);  

    return `
        ${ filteredPosts.length > 0 ? `
            ${filteredPosts.map((post, i) => {
                var link = post.fields &&  post.fields.external_link ? post.fields.external_link :  null;
                return `
                    <${link ? `a href="${link}" target="_blank"` : `span`} class="card card--basic">
                        ${ post.image ? `
                        <picture class="card__image">
                            <img class="absolute-image" src="${post.image.thumbnail}" alt="" loading="lazy"/>
                        </picture> 
                        ` : ``}
                        ${ post.subject || post.topic ? `
                        <span class="card__date-location card__date-location--column">
                            ${ post.subject ? `<h5 class="card__subject headline-3 subhead--medium-- uppercase">${formatCsvTerms(post.subject)}</h5>` : ``}
                            ${ post.topic ? `<h5 class="card__topic headline-4">${formatCsvTerms(post.topic)}</h5>` : ``}
                        </span>               
                        
                        ` : `` }
                        <span class="card__content">
                            <h3 class="card__title subhead">${post.title}</h3>
                            ${ post.fields.sub_title ? `<h4 class="card__subtitle">${post.fields.sub_title}</h4>` : ``}
                            ${ post.grade ? `<h4 class="card__grade headline-3 uppercase">${post.grade.includes('-') ? `Grades ` : `` }${post.grade}</h4>` : `` }
                            ${ post.fields.small_type ? `<div class="card__smalltype body-copy body-copy--small">${post.fields.small_type}</div>` : ``}
                            <span class="link">View&#8702</span>
                        </span>
                    </${link ? 'a' : 'span'}>
                `;
            }).join('')}              
        ` : `<p class="event-list__no-results">
                Sorry! No results for
                ${currentFilters.map((item, i) => {
                    const isFirst = i === 0;
                    const isLast = i === currentFilters.length - 1;
                    let prefix = '';
                    if (!isFirst && !isLast) {
                        prefix = ', ';
                    } else if (isLast && currentFilters.length > 1) {
                        prefix = ' and ';
                    }
                    return `${prefix}'${item}'`;
                }).join('')}  
                found.
            </p>
            `}
    `;
}

function formatCsvTerms(input) {
    return input
      .split(',') // Split by comma into array
      .map(subject => 
        subject
          .split('-') // Split by hyphen
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
          .join(' ') // Join words with space
      )
      .join(', '); // Join subjects with comma and space
  }

function selectUpdated(id){
    const updatedDropdown = document.getElementById(id);
    id.includes('subject-select') && (selectedSubject = updatedDropdown.value);
    id.includes('topic-select') && (selectedTopic = updatedDropdown.value);
    id.includes('grade-select') && (selectedGrade = updatedDropdown.value);
    renderPostList();
}


function getPostsFilterSettings() {
    const subjectsSet = new Set();
    const topicsSet = new Set();
    const gradesSet = new Set();
    // process all events in a single loop
    posts.forEach(post => {
        if (post.subject) {
            post.subject.split(',').forEach(subject => subjectsSet.add(subject));
        }
        if (post.topic) {
            post.topic.split(',').forEach(topic => topicsSet.add(topic));
        }
        if (post.grade) {
            post.grade.split(',').forEach(grade => gradesSet.add(grade));
        }
    });

    /**/
    // get subject and grade options in the same order as they appear on the allSubjects and allGrades array

    const orderedSubjects = allSubjects
        .filter(term => subjectsSet.has(term.slug))
        .map(term => ({ value: term.slug, label: term.name }));

    const orderedTopics = allTopics
        .filter(term => topicsSet.has(term.slug))
        .map(term => ({ value: term.slug, label: term.name }));

    const orderedGrades = allGrades
        .filter(term => gradesSet.has(term.slug))
        .map(term => ({ value: term.slug, label: term.name }));

    return {
        grades: orderedGrades,
        subjects: orderedSubjects,
        topics: orderedTopics,
    };
    
}




function setPostsFilterSelectOptions(){
    
    const filterSettings = getPostsFilterSettings();
    const subjectDropdown = document.querySelector('select[name="subject"]');
    const topicDropdown = document.querySelector('select[name="topic"]');
    const gradeDropdown = document.querySelector('select[name="grade"]');
    let selectedSubjectPrinted = false;
    let selectedTopicPrinted = false;
    let selectedGradePrinted = false;
    
    if( subjectDropdown ){
        subjectDropdown.innerHTML = `
        <option value="" disabled="" selected="">Subject</option>
        ${filterSettings.subjects.map((subject, i) => {
            if(selectedSubject == subject.value){
                selectedSubjectPrinted = true;
            }
            return `<option value="${subject.value}" ${ selectedSubject == subject.value ? `selected` : ``}>${subject.label}</option>`
        }).join('')} 
        ${ !selectedSubjectPrinted && selectedSubject !== `` ? `<option value="${selectedSubject}" selected>${allSubjects.find(type=>type.slug == selectedSubject).name}</option>` : ``}
        <option value="">All Subjects</option>
        `;
    }
   
    if( topicDropdown ){
        topicDropdown.innerHTML = `
        <option value="" disabled="" selected="">Topic</option>
        ${filterSettings.topics.map((topic, i) => {
            if(selectedTopic == topic.value){
                selectedTopicPrinted = true;
            }
            return `<option value="${topic.value}" ${ selectedTopic == topic.value ? `selected` : ``}>${topic.label}</option>`
        }).join('')} 
        ${ !selectedTopicPrinted && selectedTopic !== `` ? `<option value="${selectedTopic}" selected>${allTopics.find(type=>type.slug == selectedTopic).name}</option>` : ``}
        <option value="">All Topics</option>
        `;
    }

    if( gradeDropdown ){
        gradeDropdown.innerHTML = `
        <option value="" disabled="" selected="">Grade</option>
        ${filterSettings.grades.map((grade, i) => {
            if(selectedGrade == grade.value){
                selectedGradePrinted = true;
            }
            return `<option value="${grade.value}" ${ selectedGrade == grade.value ? `selected` : ``}>${grade.label}</option>`
        }).join('')} 
        ${ !selectedGradePrinted && selectedGrade !== `` ? `<option value="${selectedGrade}" selected>${allGrades.find(type=>type.slug == selectedGrade).name}</option>` : ``}
        <option value="">All Grades</option>
        `;
    }

    if( subjectDropdown || topicDropdown || gradeDropdown){
        initCustomSelects();
    }  
    // console.log(`selected - subject:${selectedSubject} | grade:${selectedGrade}`)
    // console.log(`setPostsFilterSelectOptions: ${JSON.stringify(getPostsFilterSettings())}`);
}



export {
    selectUpdated
}